"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Bar_Chart = void 0;
var d3 = void 0;
var number_with_commas = void 0;
var nvd3 = void 0;
var url_to_array = void 0;
var hasProp = {}.hasOwnProperty;

Bar_Chart = require("./bar_chart").default;

d3 = require("d3");

number_with_commas = require("../helpers/number_with_commas").default;

nvd3 = require("nvd3");

url_to_array = require("../helpers/url_to_array").default;

var Api_Usage = function Api_Usage(props) {
  _classCallCheck(this, Api_Usage);

  var $api_key_form = void 0;
  var $currently_regenerating = void 0;
  var $secret = void 0;
  var cumulative_chart = void 0;
  var fun_with_rounding = void 0;
  $api_key_form = $("#api-key-form");
  $secret = $("#secret");
  $currently_regenerating = false;
  fun_with_rounding = function fun_with_rounding(num) {
    return number_with_commas(Math.round(parseFloat(num.replace(/[^\d\.\-\ ]/g, ""))));
  };

  cumulative_chart = function () {
    cumulative_chart.prototype.graph = void 0;

    cumulative_chart.prototype.remove = function () {
      return d3.selectAll(this.graph + " > *").remove();
    };

    cumulative_chart.prototype.render = function (data, format) {
      var graph = void 0;
      var i = void 0;
      var y_val_array = void 0;
      graph = this.graph;
      this.remove();
      i = 0;
      y_val_array = [];
      y_val_array.same = function () {
        if (this.length > 0) {
          i = 1;
          while (i < this.length) {
            if (this[i] !== this[0]) {
              return false;
            }
            i++;
          }
        }
        return true;
      };
      while (i < data[0].values.length) {
        y_val_array.push(data[0].values[i].y);
        i++;
      }
      if (y_val_array.same(y_val_array === true)) {
        $(".not-enough-data-yet").removeClass("hidden");
      }
      return nv.addGraph(function () {
        var chart = void 0;
        chart = nv.models.multiChart().color(["#4c4c4c", "fd0000"]);
        chart.xAxis.showMaxMin(false).tickFormat(function (d) {
          return d3.time.format(format)(new Date(d));
        });
        chart.tooltipContent(function (key, y, e, _ref) {
          var point = _ref.point;

          var date = void 0;
          date = new Date(point.x).toLocaleDateString();
          return "<p>" + date + "<br>" + fun_with_rounding(e) + " calls</p>";
        });
        chart.xAxis.tickValues(data[0].values.map(function (_ref2) {
          var x = _ref2.x;
          return x;
        }));
        chart.yAxis1.tickFormat(d3.format(",0f"));
        chart.yAxis2.tickFormat(d3.format(",0f"));
        return d3.select(graph).datum(data).transition().duration(500).call(chart);
      });
    };

    function cumulative_chart(graph, data, format) {
      this.graph = graph;
      this.render(data, format);
    }

    return cumulative_chart;
  }();

  var bar_chart = function (_Bar_Chart) {
    _inherits(bar_chart, _Bar_Chart);

    function bar_chart() {
      _classCallCheck(this, bar_chart);

      return _possibleConstructorReturn(this, (bar_chart.__proto__ || Object.getPrototypeOf(bar_chart)).apply(this, arguments));
    }

    _createClass(bar_chart, [{
      key: "render",
      value: function render(data, format) {
        var graph = void 0;
        graph = this.graph;
        this.remove();
        return nv.addGraph(function () {
          var chart = void 0;
          chart = nv.models.discreteBarChart().x(function (d) {
            return d[0];
          }).y(function (d) {
            return d[1];
          }).staggerLabels(false).tooltips(true).showValues(false).showYAxis(false).transitionDuration(350).color(d3.scale.ordinal().range(["#4c4c4c"]));
          chart.xAxis.showMaxMin(false).tickFormat(function (d) {
            return d3.time.format(format)(new Date(d));
          });
          chart.tooltipContent(function (key, y, e, _ref3) {
            var series = _ref3.series;

            data = series.values[y - 1];
            return "<p>" + fun_with_rounding(e) + " calls</p>";
          });
          chart.valueFormat(d3.format(".0f"));
          return d3.select(graph).datum(data).transition().duration(500).call(chart);
        });
      }
    }]);

    return bar_chart;
  }(Bar_Chart);

  $("#regenerate-secret-begin").on("click", function (e) {
    e.preventDefault();
    $(this).addClass("hidden");
    return $("#regenerate-secret").removeClass("hidden");
  });

  $("#regenerate-secret").on("click", function (e) {
    var $multi_button = void 0;
    var $this = void 0;
    e.preventDefault();
    $this = $(this);
    $multi_button = $(".button.multi-step");
    if ($currently_regenerating) {
      return;
    }
    $currently_regenerating = true;

    return $.ajax({
      type: "POST",
      url: "/developers/apps/" + url_to_array[5] + "/regenerate/",
      data: $api_key_form.serialize(),
      success: function success(_ref4) {
        var new_secret = _ref4.new_secret;

        $currently_regenerating = false;
        $secret.val(new_secret);
        $this.addClass("hidden");
        return $multi_button.removeClass("hidden");
      },
      error: function error(jqXHR, textStatus, errorMessage) {
        return console.log(errorMessage);
      }
    });
  });

  $api_key_form.on("focus", "input", function () {
    return this.select;
  });

  $("document").ready(function () {
    var json = void 0;
    var limit_line = void 0;
    var time_array = void 0;
    json = $("#graph-data").data("json");

    time_array = function time_array(time, as_object) {
      var i = void 0;
      var t_array = void 0;
      i = 0;
      t_array = [];
      while (i < json.usage[time].length) {
        if (as_object === true) {
          t_array.push({
            x: new Date(json.usage[time][i].timestamp),
            y: json.usage[time][i].count
          });
        } else {
          t_array.push([new Date(json.usage[time][i].timestamp), json.usage[time][i].count]);
        }
        i++;
      }
      return t_array;
    };

    limit_line = function limit_line() {
      var last = void 0;
      var last_time = void 0;
      var len = void 0;
      var limit = void 0;
      limit = parseInt(json.client.limit_month);
      len = time_array("cumulative_month", true).length;
      last = json.usage.cumulative_month[len - 1];
      last_time = new Date(last.timestamp);
      return [{
        x: time_array("cumulative_month", true)[0].x,
        y: limit
      }, {
        x: last_time,
        y: limit
      }];
    };
    new cumulative_chart("#cumulative-chart svg", [{
      key: "Total calls",
      values: time_array("cumulative_month", true),
      type: "bar",
      yAxis: 1
    }, {
      key: "Monthly Call Limit",
      values: limit_line(),
      type: "line",
      yAxis: 1
    }], "%d");
    bar_chart = new bar_chart("#usage-chart svg", [{
      key: "Hourly",
      bar: "true",
      values: time_array("day", false)
    }], "%I");
    return $("#buttonList").on("click", "a", function (e) {
      var day = void 0;
      var hour = void 0;
      var month = void 0;
      e.preventDefault();
      $("#buttonList .active").removeClass("active");
      $(this).parents("li").addClass("active");
      $("h2 em.active").removeClass("active");
      switch ($(this).prop("id")) {
        case "hour":
          hour = [{
            key: "Hourly",
            bar: "true",
            values: time_array("day", false)
          }];
          $("h2 em.hourly").addClass("active");
          return bar_chart.render(hour, "%H");
        case "day":
          time_array("month", false);
          day = [{
            key: "Daily",
            bar: "true",
            values: time_array("month", false)
          }];
          $("h2 em.daily").addClass("active");
          return bar_chart.render(day, "%e");
        case "month":
          month = [{
            key: "Monthly",
            bar: "true",
            values: time_array("year", false)
          }];
          $("h2 em.monthly").addClass("active");
          return bar_chart.render(month, "%b");
      }
    });
  });
};

exports.default = Api_Usage;